import React, { useState, useEffect } from 'react';
import HttpInterceptor from '../../lib/HttpInterceptor';
import { toast } from 'react-toastify';

const ProductApprovals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await HttpInterceptor.get('/api/products?approvalStatus=pending');
      setProducts(response.data || []);
    } catch (error) {
      toast.error('Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await HttpInterceptor.post(`/api/products/${id}/approve`);
      toast.success('Product approved');
      fetchProducts();
    } catch (error) {
      toast.error('Failed to approve product');
    }
  };

  const handleReject = async (id) => {
    const reason = window.prompt('Enter rejection reason:');
    if (!reason) return;
    try {
      await HttpInterceptor.post(`/api/products/${id}/reject`, { rejectionReason: reason });
      toast.success('Product rejected');
      fetchProducts();
    } catch (error) {
      toast.error('Failed to reject product');
    }
  };

  return (
    <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Product Approvals</h1>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          </div>
        ) : products.length === 0 ? (
          <p className="text-gray-500 text-center py-20">No pending products</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map(product => (
              <div key={product._id} className="bg-white rounded-xl shadow-md overflow-hidden">
                <div className="h-48 bg-gray-200">
                  {product.image ? (
                    <img src={product.image} alt={product.title} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-400">No Image</div>
                  )}
                </div>
                <div className="p-4">
                  <h3 className="font-bold text-lg mb-2">{product.title}</h3>
                  <p className="text-gray-600 text-sm mb-2 line-clamp-2">{product.description}</p>
                  <p className="text-xl font-bold text-purple-600 mb-4">₹{product.price}</p>
                  <div className="flex gap-2">
                    <button
                      onClick={() => handleApprove(product._id)}
                      className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => handleReject(product._id)}
                      className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
  );
};

export default ProductApprovals;

